import { ComponentPropsWithRef } from "react";

export const SendIcon = (props: ComponentPropsWithRef<"svg">) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="22"
    height="19"
    viewBox="0 0 22 19"
    fill="none"
    {...props}
  >
    <path
      d="M2.50951 3.33273L10.0195 6.55273L2.49951 5.55273L2.50951 3.33273ZM10.0095 12.0527L2.49951 15.2727V13.0527L10.0095 12.0527ZM0.509512 0.302734L0.499512 7.30273L15.4995 9.30273L0.499512 11.3027L0.509512 18.3027L21.4995 9.30273L0.509512 0.302734Z"
      fill="currentColor"
    />
  </svg>
);
